/* Make ALL Shopify faceted filter groups single-select (Symmetry 7.x + native S&D) */
(() => {
  const FILTER_SELECTOR = 'input[type="checkbox"][name^="filter."]';

  // Derive a stable "group key" from the input's name (prefix before '[' or '=')
  function groupKeyFromName(name) {
    if (!name) return '';
    const iBracket = name.indexOf('[');
    const iEq = name.indexOf('=');
    let end = name.length;
    if (iBracket !== -1) end = Math.min(end, iBracket);
    if (iEq !== -1) end = Math.min(end, iEq);
    return name.slice(0, end);
  }

  function enforceSingleSelect(target) {
    if (!target || !target.matches?.(FILTER_SELECTOR)) return;
    if (!target.checked) return;

    const name = target.getAttribute('name') || '';
    const key = groupKeyFromName(name);
    if (!key) return;

    // Uncheck ALL other checkboxes that share this group key (works across sidebar/drawer copies)
    const allInGroup = document.querySelectorAll(`${FILTER_SELECTOR}[name^="${CSS.escape(key)}"]`);
    allInGroup.forEach(cb => {
      if (cb !== target) cb.checked = false;
    });

    // Nudge the theme/app to re-run filtering
    const form = target.closest('form');
    if (form) {
      // Many OS 2.0 themes listen for 'input' and/or 'change' on the form
      form.dispatchEvent(new Event('input', { bubbles: true }));
      form.dispatchEvent(new Event('change', { bubbles: true }));

      // Fallback: submit if no AJAX handler intercepts
      setTimeout(() => {
        try { if (typeof form.submit === 'function') form.submit(); } catch (e) {}
      }, 80);
    }
  }

  // If a group loads with multiple checked values (via URL), keep only the last one
  function normalizeInitialState(root = document) {
    // Collect by group key
    const map = new Map();
    root.querySelectorAll(FILTER_SELECTOR).forEach(cb => {
      const key = groupKeyFromName(cb.name);
      if (!key) return;
      if (!map.has(key)) map.set(key, []);
      if (cb.checked) map.get(key).push(cb);
    });
    // For any group with >1, uncheck all but the last
    map.forEach(list => {
      if (list.length > 1) list.slice(0, -1).forEach(cb => (cb.checked = false));
    });
  }

  // Delegated listener survives AJAX/section re-renders
  document.addEventListener('change', e => {
    const t = e.target;
    if (t && t.matches?.(FILTER_SELECTOR)) enforceSingleSelect(t);
  });

  document.addEventListener('DOMContentLoaded', () => {
    normalizeInitialState();
  });

  document.addEventListener('shopify:section:load', e => {
    normalizeInitialState(e.target || document);
  });
})();